/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
let SignaturePad;
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import Rails from 'rails-ujs';

window.rails = Rails;

import MuxPlayer from "@mux/mux-player";

// Load Stimulus controller files
import './controllers/public';
import './controllers/shared';

require('./ported-coffeescript/cookie-management');

import 'foundation-sites';
import './utils/dialog-polyfill';

window.SignaturePad = (SignaturePad = require('/node_modules/signature_pad/dist/signature_pad'));

require('./vendor/picker');
require('./vendor/picker.date');

require('./ported-coffeescript/abide.validators');

require('./ported-coffeescript/init.public');
require('./ported-coffeescript/app.helpers');
require('./ported-coffeescript/app.discount');
require('./ported-coffeescript/app.form');
require('./ported-coffeescript/app.date_picker');
require('./ported-coffeescript/app.time_picker');
require('./ported-coffeescript/app.stripe_elements');
require('./ported-coffeescript/app.punchpass_payment_form');
require('./ported-coffeescript/app.signature_pad');
require('./ported-coffeescript/app.confirm');

if (typeof(window.appHelpers) === 'undefined') {
  window.appHelpers = new App.Helpers();
}

const handleConfirm = event => new App.Confirm(Rails, event);

Rails.delegate(document, 'form[data-confirm-modal]', 'submit', handleConfirm);
Rails.delegate(document, 'a[data-confirm-modal]', 'click', handleConfirm);
Rails.delegate(document, 'button[data-confirm-modal]', 'click', handleConfirm);

Rails.start();
